import React from 'react';

import PropTypes from 'prop-types';

import ProductDetailCTAs from '../ProductDetailCTAs';
import WearItWith from '../WearItWith';

function ProductCTA({
  isLocked,
  isPlatinumExclusive,
  showWearItWith,
  tier,
  wearItWithProductIds,
  isAfterpayEnabled,
  isKlarnaEnabled,
}) {
  if (showWearItWith) {
    return (
      <WearItWith wearItWithProductIds={wearItWithProductIds}>
        <ProductDetailCTAs
          isLocked={isLocked}
          isPlatinumExclusive={isPlatinumExclusive}
          tier={tier}
          isAfterpayEnabled={isAfterpayEnabled}
          isKlarnaEnabled={isKlarnaEnabled}
        />
      </WearItWith>
    );
  }
  return (
    <ProductDetailCTAs
      isLocked={isLocked}
      isPlatinumExclusive={isPlatinumExclusive}
      tier={tier}
      isAfterpayEnabled={isAfterpayEnabled}
      isKlarnaEnabled={isKlarnaEnabled}
    />
  );
}

ProductCTA.propTypes = {
  isAfterpayEnabled: PropTypes.bool,
  isKlarnaEnabled: PropTypes.bool,
  isLocked: PropTypes.bool,
  isPlatinumExclusive: PropTypes.bool,
  showWearItWith: PropTypes.bool,
  tier: PropTypes.object,
  wearItWithProductIds: PropTypes.array,
};

export default ProductCTA;
